import React from "react";
import styled from "styled-components";
import { RollWidthFromTop } from "./animations";

function calcAlign(props) {
  if (props.top) {
    return "flex-start";
  }
  if (props.center) {
    return "center";
  }
  if (props.bottom) {
    return "flex-end";
  }
}

const TileContainer = styled.div`
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  height: 100%;
  flex: ${({ span }) => (span ? span : 1)};
  box-sizing: border-box;
  transition: box-shadow 0.6s ease;
  display: flex;
  flex-direction: column;
  justify-content: ${props => calcAlign(props)};
  position: relative;
  overflow-x: hidden;
  animation: ${RollWidthFromTop} 1.75s ease;
  height: 100%;
  @media screen and (max-width: 1200px) {
    &:first-child {
      flex: 0.5;
    }
  }
  @media screen and (max-width: 767px) {
    &:first-child {
      flex: 0.25;
    }
  }
  @media screen and (max-width: 713px) {
    &:first-child {
      flex: 0;
    }
  }
  &:hover {
    box-shadow: 0px 0px 67px 22px rgba(0, 0, 0, 0.85);
  }
  ${({ span }) => {
    if (span) {
      return `
        &::after {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 66.66%;
          height: 100%;
          border-right: 1px solid rgba(255,255,255,0.1);
          transition: box-shadow 0.6s ease;
        }
        &::after:hover {
          box-shadow: 0px 0px 67px 22px rgba(0, 0, 0, 0.85);
        }
      `;
    }
  }}
`;

const Tile = props => (
  <TileContainer className={props.className} {...props}>
    {props.children}
  </TileContainer>
);

export default Tile;
